<div class="modal-content">

    <div class="modal-body">

     <div class="row">
        <div class="col-lg-4 col-12 border-right assinatura">
          <h3>{{contrato?.empresa?.nome}}</h3>
          <h4 *ngIf="!contrato.proximaFatura?.cobrancaPixAutomatico">Ative seu plano pagando a 1° Fatura</h4>
          <h4 *ngIf="contrato.proximaFatura?.cobrancaPixAutomatico">Acompanhe sua cobrança por Pix Automático</h4>

         <div *ngIf="contrato.id">
           <div class="mt-2 nome-plano">
             <label>Plano:</label>  <span class="font-16 ml-2 text-success">
            <b> {{contrato.plano?.nome}}</b></span> | {{contrato.limiteContatos | number}} contatos ativos.

           </div>

          <!-- <div class="alert alert-info mt-2" *ngIf="ehCobrancaGrupo()">
             Este contrato faz parte de um grupo de faturamento. O pagamento abaixo corresponde à fatura consolidada do grupo.
           </div> -->

         </div>

         <div *ngIf="contrato.proximaFatura">
          <app-fatura-detalhes [fatura]="contrato.proximaFatura"></app-fatura-detalhes>
         </div>

          <div *ngIf="!contrato.id">
            <div class="alert alert-info mt-2" role="alert">
              <i class="mdi mdi-check-all mr-2"></i> Aguardando contrato ser registrado no sistema.
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

          </div>

          <div *ngIf="!contrato.proximaFatura">
            <div class="alert alert-info mt-2" role="alert">
              <i class="mdi mdi-check-all mr-2"></i> Aguardando criação da fatura
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

          </div>


          <div class="alert alert-danger alert-dismissible fade show mt-2" role="alert" *ngIf="erro">
            <i class="mdi mdi-check-all mr-2"></i> {{erro}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Fechar">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>


          <div class="aceite-documentos" *ngIf="aceiteDocumentosPendente">
            <div class="aceite-documentos-opcao">
              <input id="aceite-documentos" type="checkbox" [(ngModel)]="aceitouDocumentos">
              <label for="aceite-documentos">
                Li e aceito o <a href="/contrato-adesao-uso" target="_blank" rel="noopener">Contrato de Adesão</a>
                e os <a href="/termos-de-uso" target="_blank" rel="noopener">Termos de Uso</a>.
              </label>
            </div>
            <button type="button" class="btn btn-success"
                    [disabled]="!aceitouDocumentos || aceitandoDocumentos"
                    (click)="continueParaPagamento()">
              {{aceitandoDocumentos ? 'Confirmando aceite...' : 'Continuar para pagamento'}}
            </button>
          </div>

          <div class="meios-pagamento" *ngIf="!aceiteDocumentosPendente">

          <div class="alert alert-info mt-2" *ngIf="contrato.proximaFatura && !contrato.proximaFatura.cobrancaPixAutomatico && !faturaPodeSerPaga && !pago">
            Esta fatura não está disponível para pagamento. Status: {{contrato.proximaFatura.status}}.
          </div>

          <div class="abas-pagamento" *ngIf="!pago && formasPagamentoDisponiveis.length">
            <button type="button" *ngFor="let forma of formasPagamentoDisponiveis"
                    [class.ativa]="formaPagamentoAtiva === forma"
                    (click)="selecioneFormaPagamento(forma)">
              <i class="fa"
                 [ngClass]="{
                   'fa-qrcode': forma === 'pix' || forma === 'pix-auto',
                   'fa-credit-card': forma === 'cartao',
                   'fa-barcode': forma === 'boleto'
                 }"></i>
              <span *ngIf="forma === 'pix'">Pix</span>
              <span *ngIf="forma === 'pix-auto'">Pix Automático</span>
              <span *ngIf="forma === 'cartao'">Cartão</span>
              <span *ngIf="forma === 'boleto'">Boleto</span>
            </button>
          </div>

          <div [hidden]="pago || formaPagamentoAtiva !== 'cartao'"
               *ngIf="contrato.proximaFatura && !contrato.proximaFatura.cobrancaPixAutomatico && contrato.pagaNoCartao">
              <section class="autenticacao-3ds" *ngIf="urlAutenticacao3DSSegura">
                <h4>Autentique o cartão</h4>
                <p>Conclua a validação solicitada pelo banco emissor. O pagamento será confirmado depois da autorização.</p>
                <iframe [src]="urlAutenticacao3DSSegura" title="Autenticação 3D Secure"></iframe>
                <a [href]="urlAutenticacao3DS" target="_blank" rel="noopener">Abrir autenticação em outra janela</a>
              </section>
              <div class="alert alert-info" *ngIf="pagamentoCartaoPendente && !urlAutenticacao3DSSegura">
                Pagamento enviado. Aguardando a confirmação do banco.
              </div>
              <cad-cartaocredito #cccompoment (onCriou)="ativeViaCartao($event)"
                                 [parcelamento]="{numeroParcelas: (contrato.proximaFatura?.parcelamentoMaximo || contrato.numeroParcelas), total: contrato.proximaFatura.total}"
                                 [provedorPagamento]="contrato.proximaFatura?.provedorPagamento"
                                 *ngIf="!pagamentoCartaoPendente">

              </cad-cartaocredito>
          </div>

          <div class="alert alert-warning" *ngIf="!pago && contrato.proximaFatura?.pixAutomatico?.jornada === 3 && contrato.proximaFatura?.pixAutomatico?.adesaoRecusada">
            A adesão ao Pix Automático foi recusada.
            Acompanhe o resultado desta cobrança antes de tentar outro pagamento.
          </div>
          <app-pagamento-pix-fatura class="pix-destaque" *ngIf="contrato.proximaFatura?.pix && !contrato.proximaFatura.cobrancaPixAutomatico"
               [hidden]="pago || (formaPagamentoAtiva !== 'pix' && formaPagamentoAtiva !== 'pix-auto')"
               [pix]="contrato.proximaFatura.pix"></app-pagamento-pix-fatura>

          <div class="alert alert-info" *ngIf="contrato.proximaFatura?.pixAutomatico && !contrato.proximaFatura.cobrancaPixAutomatico && !contrato.proximaFatura.pixAutomatico.adesaoRecusada"
               [hidden]="pago || (formaPagamentoAtiva !== 'pix-auto' && formaPagamentoAtiva !== 'pix')">
            <span *ngIf="contrato.proximaFatura.pixAutomatico.jornada === 4; else adesaoObrigatoria">
              <strong class="d-block">Pagamento por Pix com adesão opcional</strong>
              Pague esta fatura por Pix. No aplicativo do banco, você pode escolher autorizar as próximas cobranças pelo Pix Automático.
              Essa adesão é opcional e não interfere no pagamento desta fatura.
            </span>
            <ng-template #adesaoObrigatoria>
              <strong class="d-block">Pagamento e adesão ao Pix Automático</strong>
              No aplicativo do banco, confirme o pagamento desta fatura junto com a autorização
              das próximas cobranças por Pix Automático.
            </ng-template>
            Confira os valores, a periodicidade e as condições antes de confirmar no banco.
            <span *ngIf="contrato.proximaFatura.pixAutomatico?.recurrency?.recurrencyMinAmount">
              O limite de débito autorizado no banco deve ser de, pelo menos,
              {{contrato.proximaFatura.pixAutomatico.recurrency.recurrencyMinAmount | currency:'BRL'}}.
            </span>
          </div>

          <div class="alert alert-info" *ngIf="pago && !contrato.proximaFatura?.cobrancaPixAutomatico && contrato.proximaFatura?.pixAutomatico as automatico">
            <span *ngIf="automatico.statusAutorizacao === 'CONFIRMED'">Pix Automático autorizado para as próximas cobranças.</span>
            <span *ngIf="automatico.statusAutorizacao === 'CANCELLED'">A autorização do Pix Automático foi cancelada. O pagamento desta fatura permanece confirmado.</span>
            <span *ngIf="automatico.statusAutorizacao === 'CANCELLATION_REQUESTED'">O cancelamento da autorização está em processamento. O pagamento desta fatura permanece confirmado.</span>
            <span *ngIf="['ERROR', 'EXPIRED', 'REJECTED'].includes(automatico.statusAutorizacao)">
              O pagamento está confirmado, mas a autorização não foi concluída. Solicite um link somente de
              autorização das próximas cobranças pelo Pix Automático, sem pagar novamente.
            </span>
            <span *ngIf="!automatico.statusAutorizacao || ['PENDING', 'AWAITING_DEBTOR'].includes(automatico.statusAutorizacao)">
              O pagamento está confirmado. A autorização do Pix Automático ainda não foi confirmada.
              Aguarde a atualização ou entre em contato com o responsável pela assinatura.
            </span>
          </div>
          <section class="pix-resumo" *ngIf="contrato.proximaFatura?.pixAutomatico?.resumo as resumo">
            <h5>Dados do recebedor e da recorrência</h5>
            <dl>
              <div class="pix-resumo__recebedor" *ngIf="resumo.recebedor">
                <dt>Recebedor</dt><dd>{{resumo.recebedor}}<small *ngIf="resumo.documentoRecebedor">CPF/CNPJ: {{resumo.documentoRecebedor}}</small></dd>
              </div>
              <div *ngIf="resumo.contrato"><dt>Contrato</dt><dd>{{resumo.contrato}}<small *ngIf="resumo.descricao">{{resumo.descricao}}</small></dd></div>
              <div *ngIf="resumo.frequencia"><dt>Periodicidade</dt><dd>{{ {MONTHLY: 'Mensal', QUARTER: 'Trimestral', SEMESTER: 'Semestral', YEARLY: 'Anual'}[resumo.frequencia] }}</dd></div>
              <div *ngIf="resumo.inicio"><dt>Próximos débitos a partir de</dt><dd>{{resumo.inicio | date:'dd/MM/yyyy'}}</dd></div>
              <div *ngIf="resumo.valorFixo != null"><dt>Valor por cobrança</dt><dd>{{resumo.valorFixo | currency:'BRL'}}</dd></div>
              <div><dt>Duração</dt><dd>{{resumo.fim ? ('Até ' + (resumo.fim | date:'dd/MM/yyyy')) : 'Até o cancelamento da autorização'}}</dd></div>
            </dl>
            <p *ngIf="resumo.valorFixo == null">O valor de cada fatura será informado antes do débito, respeitando o limite autorizado no banco.</p>
            <p *ngIf="resumo.permiteRetentativas">Poderão ocorrer novas tentativas de débito conforme as regras do Pix Automático.</p>
          </section>

          <span [hidden]="!pago || contrato.proximaFatura?.cobrancaPixAutomatico">
             <h4 class="text-success text-center">Seu plano foi ativado com sucesso!</h4>
          </span>

          <div *ngIf="contrato.proximaFatura?.boleto && !contrato.proximaFatura.cobrancaPixAutomatico"
               [hidden]="pago || formaPagamentoAtiva !== 'boleto'" class="conteudo-pagamento">
            <img class="boleto" [src]="contrato.proximaFatura.boleto.urlCodigoBarras" >

            <span class="font-12 text-center d-block">
              {{contrato.proximaFatura.boleto.codigoBarras}}
            </span>

            <a class="btn btn-info mt-2" target="_blank" href="{{contrato.proximaFatura.linkPagamento}}"   >
              Imprimir boleto
            </a>

          </div>
          </div>

          <footer class="pix-atualizacao" *ngIf="acompanhaPixAutomatico" role="status">
            <p>O status é atualizado automaticamente enquanto houver confirmação pendente.</p>
            <button type="button" class="btn btn-outline-secondary" [disabled]="atualizandoStatusPix" (click)="atualizeStatusPix()">
              {{atualizandoStatusPix ? 'Atualizando...' : 'Atualizar status'}}
            </button>
            <p class="text-danger mt-2" *ngIf="erroStatusPix">{{erroStatusPix}}</p>
          </footer>

        </div>

        <div class="col-lg-8 col-0 quadro">
          <div class="bg-cartao" *ngIf="formaPagamentoAtiva === 'cartao'">
            <div class="promo-info ">
              <h3>Ative seu plano com seu cartão de crédito e garanta seu desconto.</h3>
              <p>E começe a melhorar o ciclo de retorno diminuindo o tempo de recorrência
              dos seus clientes.</p>
            </div>

          </div>

          <div class="bg-ativacao" *ngIf="formaPagamentoAtiva === 'boleto' ">
            <div class="promo-info ">
              <h3>Ative seu plano pagando o boleto e começe a faturar mais.</h3>
              <p>E começe a melhorar o ciclo de retorno diminuindo o tempo de recorrência
                dos seus clientes.</p>
            </div>
          </div>

          <div class="bg-ativacao" *ngIf="formaPagamentoAtiva === 'pix'">
            <div class="promo-info ">
              <h3>Ative seu plano fazendo transferência via Pix e começe a faturar mais.</h3>
              <p>E começe a melhorar o ciclo de retorno diminuindo o tempo de recorrência
                dos seus clientes.</p>
            </div>
          </div>

          <div class="bg-ativacao" *ngIf="formaPagamentoAtiva === 'pix-auto'">
            <div class="promo-info">
              <h3>Ative seu plano e autorize as próximas cobranças com Pix Automático.</h3>
              <p>Você confere e define o teto da cobrança no aplicativo do seu banco.</p>
            </div>
          </div>

        </div>
     </div>


    </div>

</div>
